import { useContext } from 'react';
import { Button } from '@shared/components/Button';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBImage, MBImageURISource } from '@shared/components/image';
import { ColorThemeContext, grid } from '@shared/styles';

export interface MBEmptyListPlaceholderProps {
  title?: string;
  description?: string;
  image?: MBImageURISource;
  imageTintColor?: string;
  imageSize?: number;
  imagePosition?: 'above' | 'below';
  imageVerticalGap?: number;
  buttonTitle?: string;
  onButtonPress?(): void;
  testID?: string;
  className?: string;
}

export function MBEmptyListPlaceholder({
  title,
  description,
  image,
  imageTintColor,
  imageSize = grid(24),
  imagePosition = 'above',
  imageVerticalGap = 2,
  buttonTitle,
  onButtonPress,
  testID,
  className,
}: MBEmptyListPlaceholderProps) {
  const colors = useContext(ColorThemeContext);

  const imageElement = image && (
    <MBImage
      source={image}
      tintColor={imageTintColor !== undefined ? imageTintColor : colors.highlightActive}
      style={{ height: imageSize, width: '100%' }}
      resizeMode="contain"
    />
  );

  return (
    <View fill center padding={2} testID={testID} className={className}>
      {imagePosition === 'above' && imageElement}
      {imagePosition === 'above' && image && <View paddingTop={imageVerticalGap} />}
      {!!title && (
        <Text size="h4" align="center" balance style={styles.title}>
          {title}
        </Text>
      )}
      <View paddingTop={2} />
      {!!description && (
        <Text size="body1" inactive align="center" balance style={styles.description}>
          {description}
        </Text>
      )}
      {imagePosition === 'below' && image && <View paddingTop={imageVerticalGap} />}
      {imagePosition === 'below' && imageElement}
      <View paddingTop={2} />
      {!!buttonTitle && !!onButtonPress && (
        <Button variant="secondary" size="medium" label={buttonTitle} onClick={onButtonPress} />
      )}
    </View>
  );
}

const styles = {
  title: {
    maxWidth: grid(60),
  },
  description: {
    maxWidth: grid(60),
  },
};
